export const EMPLOYEES_CONSTANTS = () => ({
  ROLE_BLACKLIST: ['SUPER_ADMIN'],
  ROLE_BLACKLIST_PER_MERCHANT_PRODUCT: {
    11: ['WAITER', 'HEADWAITER', 'MANAGER', 'RESERVATIONAGENT'],
  },
  HIDE_PASSWORD_FIELD_FOR_ROLES: ['WAITER', 'HEADWAITER'],
  ROLES: {
    HEADWAITER: 'HEADWAITER',
    MANAGER: 'MANAGER',
    MERCHANT: 'MERCHANT',
    RESERVATIONAGENT: 'RESERVATIONAGENT',
    SUPER_ADMIN: 'SUPER_ADMIN',
    WAITER: 'WAITER',
  },
});



// WEBPACK FOOTER //
// ./src/app/merchants/employees/employees.constants.js